import axios from 'axios';

export default {
    namespaced: true,

    actions: {
        // アップロードファイルチェックAPI
        async check({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            await axios.post('/api/bulk-add-users/check', data.formData)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    result = error.response;
                })

            // 通信結果を返す
            return result;
        },

        // アップロードファイルの最大サイズとアップロードファイルの選択可能な拡張子の取得API
        async getParameters() {
            // result の初期化
            let result: any;

            // パラメータ情報をback側から取得
            await axios.post('/api/bulk-add-users/parameter')
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定
                    result = error.response;
                });
            // 通信結果を返す
            return result;
        },

        // ユーザー一括登録チェック結果フィルター情報取得API
        async getFilterConditions() {
            // resultの初期化
            let result: any;

            // URL:GET /api/bulk-add-users/filter-conditions
            await axios.get('/api/bulk-add-users/filter-conditions')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                });

            // 通信結果を返す
            return result;
        },

        // ユーザー一括登録チェック結果情報取得API
        async getResults({ state, commit, rootState }: any, data: any) {
            // 通信結果
            let result: any;

            // ユーザー一括登録チェック結果情報をback側から取得
            // URL:GET /api/bulk-add-users/results
            // params:ページ番号
            //        １ページあたりの行数
            //        ソートキー
            //        ソート順
            //        フィルタ情報
            await axios.get('/api/bulk-add-users/results', {
                params: {
                    page: data.page,
                    itemsPerPage: data.itemsPerPage,
                    sortKey : data.sortKey,
                    sortOrder : data.sortOrder,
                    filterParams : data.filterParams
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                });

            // 通信結果を返す
            return result;
        },

        // ユーザー一括登録チェック結果Excel出力API
        async outputResults({ state, commit, rootState }: any, data: any) {
            // Excelファイル名の格納
            const fileName = data.fileName;

            // resultの初期化
            let result: any;

            // URL:GET /api/bulk-add-users/check-result-excel
            // params:ソートキー
            //        ソート順
            //        フィルタ情報
            //        正常データのExcel出力か
            await axios.get('/api/bulk-add-users/check-result-excel', {
                params: {
                    sortKey : data.sortKey,
                    sortOrder : data.sortOrder,
                    filterParams : data.filterParams,
                    isNormalData : data.isNormalData
                },
                // レスポンスのバイナリデータをarraybufferで受け取る
                responseType: 'arraybuffer'
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;

                    // レスポンス結果のバイナリデータが存在する場合、Excelファイルを作成する
                    if (response.data) {
                        // レスポンス結果のバイナリデータをBlobオブジェクトにする
                        const blob = new Blob([response.data]);

                        // BlobオブジェクトのURLオブジェクトを作成する
                        const objURL: string = window.URL.createObjectURL(blob);

                        // エレメントを作成し、要素にURLオブジェクトとダウンロードするファイル名を格納する
                        const dlLink: HTMLAnchorElement = document.createElement('a');
                        dlLink.href = objURL;
                        dlLink.download = fileName;

                        // 親のHTMLのbody要素に子ノードを追加し、作成した要素を追加する
                        document.body.appendChild(dlLink);

                        // 追加した子ノードの要素に対してクリックイベントを起こし、ファイルをダウンロードする
                        dlLink.click();

                        // 子ノードを削除する
                        document.body.removeChild(dlLink);
                    }
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                    // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                    const errorMessage = Array.from(new Uint8Array(error.response.data));

                    // 作成した文字コードを文字列に変換し、JSON形式に変換する
                    result.data = JSON.parse(String.fromCharCode.apply("", errorMessage));
                });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        },

        // 登録完了 パスワード有無取得API
        async existPasswords() {
            // 通信結果
            let result: any;

            // URL:GET /api/bulk-add-users/check-passwords
            // params:なし
            await axios.get('/api/bulk-add-users/check-passwords')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定
                    result = error.response;
                });
            // 通信結果を返す
            return result;
        },

        // ユーザー一括登録パスワード情報EXCEL出力API
        async outputPasswords({ state, commit, rootState }: any, data: any) {
            // Excelファイル名の格納
            const fileName = data.fileName;

            // 通信結果
            let result: any;

            // URL:GET /api/bulk-add-users/password-excel
            // params:なし
            await axios.get(`/api/bulk-add-users/password-excel`,
                {
                    // レスポンスのバイナリデータをarraybufferで受け取る
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;

                    // レスポンス結果のバイナリデータが存在する場合、Excelファイルを作成する
                    if (response.data) {
                        // レスポンス結果のバイナリデータをBlobオブジェクトにする
                        const blob = new Blob([response.data]);

                        // BlobオブジェクトのURLオブジェクトを作成する
                        const objURL: string = window.URL.createObjectURL(blob);

                        // エレメントを作成し、要素にURLオブジェクトとダウンロードするファイル名を格納する
                        const dlLink: HTMLAnchorElement = document.createElement('a');
                        dlLink.href = objURL;
                        dlLink.download = fileName;

                        // 親のHTMLのbody要素に子ノードを追加し、作成した要素を追加する
                        document.body.appendChild(dlLink);

                        // 追加した子ノードの要素に対してクリックイベントを起こし、ファイルをダウンロードする
                        dlLink.click();

                        // 子ノードを削除する
                        document.body.removeChild(dlLink);
                    }
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                    // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                    const errorMessage = Array.from(new Uint8Array(error.response.data));

                    // 作成した文字コードを文字列に変換し、JSON形式に変換する
                    result.data = JSON.parse(String.fromCharCode.apply("", errorMessage));
                });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        },

        // チェック済みデータ登録処理API
        async bulkRegistration() {
            // 通信結果の初期化
            let result: any;

            // 画面に表示された内容を中間テーブルに登録する
            await axios.post('/api/bulk-add-users/add')
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // エラー通信結果を設定
                    result = error.response;
                })

            // 通信結果を返す
            return result;
        }
    }
}
